import React, { ReactNode, useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

import { DistanceField } from '@paragon/material';

const REFERENCE_ACTUAL_LENGTH = 12;

interface ScaleRatio {
  drawingLength: number;
  actualLength: number;
}

interface ScaleRatioFieldProps {
  onFocus?: () => void;
  onBlur?: () => void;

  scale: number;
  onSubmit: (scale: number) => void;

  actionButton?: ReactNode;
}

export function ScaleRatioField(props: ScaleRatioFieldProps) {
  const { scale, onSubmit, onFocus, onBlur } = props;

  const [ratio, setRatio] = useState<ScaleRatio>(() => ({
    drawingLength: REFERENCE_ACTUAL_LENGTH / scale,
    actualLength: REFERENCE_ACTUAL_LENGTH,
  }));

  useEffect(() => {
    setRatio({
      drawingLength: REFERENCE_ACTUAL_LENGTH / scale,
      actualLength: REFERENCE_ACTUAL_LENGTH,
    });
  }, [scale]);

  function submitRatio(newRatio: ScaleRatio) {
    const newScale = newRatio.actualLength / newRatio.drawingLength;

    setRatio(newRatio);
    onSubmit(newScale);
  }

  function handleDrawingLengthSubmit(submittedDrawingLength: number) {
    if (submittedDrawingLength > 0 && ratio.actualLength > 0) {
      submitRatio({ drawingLength: submittedDrawingLength, actualLength: ratio.actualLength });
    }
  }

  function handleActualLengthSubmit(submittedActualLength: number) {
    if (submittedActualLength > 0 && ratio.drawingLength > 0) {
      submitRatio({ drawingLength: ratio.drawingLength, actualLength: submittedActualLength });
    }
  }

  return (
    <div>
      <Typography variant="h6">Scale:</Typography>

      <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-end', minWidth: 0 }}>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'baseline', flex: 1, minWidth: 0 }}>
          <DistanceField
            sx={{ flex: 1, minWidth: 0, marginBottom: 0 }}
            label="Drawing"
            value={ratio.drawingLength}
            onSubmit={handleDrawingLengthSubmit}
            onFocus={onFocus}
            onBlur={onBlur}
          />
          =
          <DistanceField
            sx={{ flex: 1, minWidth: 0, marginBottom: 0 }}
            label="Actual"
            value={ratio.actualLength}
            onSubmit={handleActualLengthSubmit}
            onFocus={onFocus}
            onBlur={onBlur}
          />
        </Box>
        {props.actionButton}
      </Box>
    </div>
  );
}
